import loopCreate from './loopCreate';
import loopFix from './loopFix';
import loopDestroy from './loopDestroy';
export default {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/loop/index.js
// module id = 1166
// module chunks = 168